import { api, TOKEN_KEY } from './client.js'

export const OPERATION_DEADLINE_MS = 2 * 60 * 60_000
const MAX_STREAM_DROPS = 5

export function streamOperation(operationId, { onStatus, poll = pollOperation } = {}) {
  return new Promise((resolve, reject) => {
    const reportPolledResult = promise =>
      promise
        .then(op => {
          onStatus?.(op)
          return op
        })
        .then(resolve, reject)
    if (typeof EventSource === 'undefined') {
      reportPolledResult(poll(operationId))
      return
    }
    const token = localStorage.getItem(TOKEN_KEY) || ''
    const es = new EventSource(`/api/operations/${operationId}/events?access_token=${encodeURIComponent(token)}`)
    let settled = false
    let timeoutMs = OPERATION_DEADLINE_MS
    const finish = (fn, arg) => {
      if (settled) return
      settled = true
      es.close()
      fn(arg)
    }

    es.addEventListener('open', e => {
      try {
        timeoutMs = JSON.parse(e.data).deadlineMs || timeoutMs
      } catch {
        /* keep the default */
      }
    })
    es.addEventListener('status', e => {
      let data
      try {
        data = JSON.parse(e.data)
      } catch {
        return
      }
      onStatus?.(data)
      if (data.status === 'DONE' || data.status === 'ERROR') finish(resolve, data)
    })
    let drops = 0
    es.addEventListener('error', () => {
      if (settled) return
      const closed = typeof EventSource !== 'undefined' && es.readyState === EventSource.CLOSED
      drops += 1
      if (!closed && drops <= MAX_STREAM_DROPS) return
      settled = true
      es.close()
      reportPolledResult(poll(operationId, { timeoutMs }))
    })
  })
}

export async function pollOperation(
  operationId,
  {
    intervalMs = 1500,
    timeoutMs = OPERATION_DEADLINE_MS,
    get = url => api.get(url).then(r => r.data),
    sleep = ms => new Promise(r => setTimeout(r, ms))
  } = {}
) {
  const deadline = Date.now() + timeoutMs
  let transientErrors = 0
  while (true) {
    try {
      const data = await get(`/api/operations/${operationId}`)
      transientErrors = 0
      if (data.status === 'DONE' || data.status === 'ERROR') return data
    } catch (err) {
      transientErrors += 1
      if (transientErrors > 8) throw err
    }
    if (Date.now() > deadline) throw new Error('operation timed out')
    await sleep(intervalMs)
  }
}
